/* Shade Patch concept B: content-page behaviour (chapter links, copy link). Small custom elements, no dependencies. */
(() => {
  /* Sticky chapter links: marks the chapter in view with aria-current and keeps that pill visible in the mobile scroller. */
  if (!customElements.get('spb-chapters')) {
    customElements.define('spb-chapters', class extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('a[data-target]')];
        this.targets = this.links.map((a) => document.getElementById(a.dataset.target));
        if (!this.links.length || !('IntersectionObserver' in window)) return;
        this.visible = new Set();
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => (e.isIntersecting ? this.visible.add(e.target) : this.visible.delete(e.target)));
          this.update();
        }, { rootMargin: '-35% 0px -55% 0px' });
        this.targets.forEach((t) => t && this.io.observe(t));
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      update() {
        let idx = -1;
        this.targets.forEach((t, i) => { if (t && this.visible.has(t)) idx = i; });
        if (idx < 0) { this.links.forEach((a) => a.removeAttribute('aria-current')); return; }
        this.links.forEach((a, i) => (i === idx ? a.setAttribute('aria-current', 'location') : a.removeAttribute('aria-current')));
        const list = this.querySelector('.spb-chap__list');
        const link = this.links[idx];
        if (list && list.scrollWidth > list.clientWidth) {
          const left = link.offsetLeft - (list.clientWidth - link.offsetWidth) / 2;
          list.scrollTo({ left, behavior: window.spb && window.spb.reduceMotion ? 'auto' : 'smooth' });
        }
      }
    });
  }

  /* Copy link button for article sharing. */
  if (!customElements.get('spb-copy-link')) {
    customElements.define('spb-copy-link', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        if (!btn) return;
        btn.addEventListener('click', async () => {
          const url = this.dataset.url || location.href;
          try {
            await navigator.clipboard.writeText(url);
          } catch (e) {
            const tmp = document.createElement('input');
            tmp.value = url;
            document.body.appendChild(tmp);
            tmp.select();
            try { document.execCommand('copy'); } catch (err) { /* no clipboard access */ }
            tmp.remove();
          }
          const label = btn.querySelector('span');
          const original = label ? label.textContent : '';
          if (label) label.textContent = this.dataset.done || 'Copied';
          if (status) status.textContent = this.dataset.done || 'Copied';
          clearTimeout(this.timer);
          this.timer = setTimeout(() => { if (label) label.textContent = original; if (status) status.textContent = ''; }, 2400);
        });
      }
    });
  }
})();
